import { RootState } from 'rootReducer';

// @ts-ignore
export const tripReqDataSelector = (state: RootState) => state.commonReducer.tripFieldsReducer.reqData;
export const tripLoadedReqDataSelector = (state: RootState) =>
  ({
    // @ts-ignore
    loaded: state.commonReducer.tripFieldsReducer.loaded,
    // @ts-ignore
    paramName: state.commonReducer.tripFieldsReducer.paramName,
  } || {});
// @ts-ignore
export const tripLoadingSelector = (state: RootState) => state.commonReducer.tripFieldsReducer.loading || false;
// @ts-ignore
export const errorReqSelector = (state: RootState) => state.commonReducer.tripFieldsReducer.errorReqData;
